/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type RemoveItemFromHardwareRequestMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type RemoveItemFromHardwareRequestMutation = {
  removeItemFromHardwareRequest: Pick<Types.Success, "status">;
};

export const RemoveItemFromHardwareRequestDocument = gql`
  mutation RemoveItemFromHardwareRequest($id: Float!) {
    removeItemFromHardwareRequest(id: $id) {
      status
    }
  }
`;

/**
 * __useRemoveItemFromHardwareRequestMutation__
 *
 * To run a mutation, you first call `useRemoveItemFromHardwareRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemFromHardwareRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemFromHardwareRequestMutation, { data, loading, error }] = useRemoveItemFromHardwareRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveItemFromHardwareRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RemoveItemFromHardwareRequestMutation,
    RemoveItemFromHardwareRequestMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    RemoveItemFromHardwareRequestMutation,
    RemoveItemFromHardwareRequestMutationVariables
  >(RemoveItemFromHardwareRequestDocument, baseOptions);
}
export type RemoveItemFromHardwareRequestMutationHookResult = ReturnType<
  typeof useRemoveItemFromHardwareRequestMutation
>;
export type RemoveItemFromHardwareRequestMutationResult =
  ApolloReactCommon.MutationResult<RemoveItemFromHardwareRequestMutation>;
export type RemoveItemFromHardwareRequestMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RemoveItemFromHardwareRequestMutation,
    RemoveItemFromHardwareRequestMutationVariables
  >;
